<div class="p-3">
    <div class="modal-header">
        <p class="modal-title"><strong>{{ isEditMode ? 'Update Exit Activity':'Create Exit Activity'}}</strong></p>
     <button type="button" (click)="modal.dismiss()" class="btn-close" aria-label="Close"></button>


    </div>
    <div class="modal-body p-3">
        <form [formGroup]="createForm" class="d-flex flex-column row">
            <div class="row m-0 pt-2">

                <div class="col-4">
                    <label>Activity type *</label>
                    <ng-select [items]="activityTypes" [closeOnSelect]="false" [multiple]="false"
                        bindLabel="displayText" bindValue="id" formControlName="activityType">
                    </ng-select>
                </div>
                <div class="col-4">
                    <label for="active">Exit type*</label>
                    <ng-select [items]="exitTypes" [multiple]="false" bindLabel="displayText" formControlName="exitType"
                        bindValue="id" (change)="onExitChange($event)">
                    </ng-select>
                </div>
                <div class="col-2">
                    <label>Order *</label>
                    <input type="number" class="w-100 form-control form-control-sm" formControlName="order" />
                </div>

            </div>
            <div class="row m-0 py-2">
                <div class="col">
                    <label>Header *</label>
                    <textarea class="w-100 form-control form-control-sm" formControlName="header"></textarea>
                </div>
                <div class="col">
                    <label>Description *</label>
                    <textarea class="w-100 form-control form-control-sm" formControlName="description"></textarea>
                </div>
            </div>


            <div class="row m-0">
                <div class="px-3">
                    <label for="active">
                        <input id="active" type="checkbox" formControlName="isActive" />
                        Active
                    </label>
                </div>
            </div>

            <div class="border-top">
                <div class="px-3"><b>Additional information</b></div>
                <div class="row m-0 py-2">
                    <div class="col">
                        <label>Office Location</label>
                        <ng-select [items]="officeLocation" [closeOnSelect]="false" [multiple]="true"
                            bindLabel="displayText" bindValue="id" formControlName="officeLocation">
                            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                <div class="ng-value" *ngFor="let item of items | slice:0:3">
                                    <span class="ng-value-label">
                                        {{item.displayText}}</span>
                                    <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                                </div>
                                <div class="ng-value" *ngIf="items.length > 3">
                                    <span class="ng-value-label">+{{items.length - 3}}</span>
                                </div>
                            </ng-template>
                        </ng-select>
                    </div>
                    <div class="col">
                        <label>Nationality type</label>
                        <ng-select [items]="nationalityType" [closeOnSelect]="false" [multiple]="true"
                            bindLabel="displayText" bindValue="id" formControlName="nationalityType">
                            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                <div class="ng-value" *ngFor="let item of items | slice:0:3">
                                    <span class="ng-value-label">
                                        {{item.displayText}}</span>
                                    <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                                </div>
                                <div class="ng-value" *ngIf="items.length > 3">
                                    <span class="ng-value-label">+{{items.length - 3}}</span>
                                </div>
                            </ng-template>
                        </ng-select>
                    </div>


                    <div class="col">
                        <label>Exit sub type</label>
                        <ng-select [items]="exitSubTypeInfo" [closeOnSelect]="false" [multiple]="true"
                            bindLabel="displayText" bindValue="id" formControlName="exitSubType">
                            <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                                <div class="ng-value" *ngFor="let item of items | slice:0:3">
                                    <span class="ng-value-label">
                                        {{item.displayText}}</span>
                                    <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                                </div>
                                <div class="ng-value" *ngIf="items.length > 3">
                                    <span class="ng-value-label">+{{items.length - 3}}</span>
                                </div>
                            </ng-template>
                        </ng-select>
                    </div>
                </div>
            </div>
            <div class="row m-0">


                <div class="col-md-4">
                    <label>Rank</label>
                    <ng-select [items]="rank" [closeOnSelect]="false" [multiple]="true" bindLabel="rankName"
                        bindValue="rankCode" formControlName="rank">
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items | slice:0:1">
                                <span class="ng-value-label">
                                    {{item.rankName}}</span>
                                <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">+{{items.length - 1}}</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="col-md-4 mt-5">
                    <label for="active">
                        <input id="active" type="checkbox" formControlName="isPartner" />
                        Is Partner
                    </label>
                </div>

            </div>


            <div class="row my-3 text-center">

                <div class="p-3 col">
                    <button (click)="createActivity()" eosDebounce [disabled]="!createForm.valid"
                        class="btn btn-secondary mx-2" type="submit">{{!isEditMode ? 'Create' :'Update'}}</button>
                    <button class="btn btn-outline-primary me-2" (click)="onCancel()">
                        Close</button>
                </div>
            </div>





        </form>
    </div>
</div>